import React, { useState } from "react";
import { Modal, Box, Typography, Divider, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LoginPopup from "../Login/LoginPopup";

const PaymentSuccessPopup = ({ open, onClose, customer, subscriptionPlan }) => {
    const [loginPopupOpen, setLoginPopupOpen] = useState(false);

    // console.log("subscriptionPlan", subscriptionPlan, "customer", customer)

    if (!open) return null;

    const handleLoginClick = () => {
        setLoginPopupOpen(true);
    };

    return (
        <>
            <Modal
                open={open}
                disableEscapeKeyDown
                aria-labelledby="payment-success-title"
                aria-describedby="payment-success-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        width: { xs: "90%", sm: 400 },
                        textAlign: "center",
                        outline: "none",
                    }}
                >
                    <CheckCircleIcon color="success" sx={{ fontSize: 50, mb: 2 }} />
                    <Typography id="payment-success-title" variant="h4" fontWeight="bold" gutterBottom>
                        Payment Successful!
                    </Typography>

                    <Box my={2} >
                        <Typography variant="h6" fontWeight="medium"> {customer.firstName} {customer.lastName} </Typography>
                        <Typography variant="body2" > ({customer.email}) </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ textAlign: "left", bgcolor: "#f5f5f5", p: 2, borderRadius: 2, mb: 3, }} >
                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom> Subscription Details </Typography>

                        <Typography variant="body2" sx={{ mb: 0.5 }}> Duration: {subscriptionPlan.duration} </Typography>
                        <Typography variant="body2">Price: {subscriptionPlan.price} ₹</Typography>
                    </Box>

                    <Button variant="contained" sx={{ mt: 3 }} fullWidth onClick={handleLoginClick} >
                        Login to Portal
                    </Button>
                </Box>
            </Modal>

            {loginPopupOpen && (
                <LoginPopup open={loginPopupOpen} onClose={() => setLoginPopupOpen(false)} prefillEmail={customer.email}/>
            )}
        </>
    );
};

export default PaymentSuccessPopup;
